import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { CreateChancel, Input, TextareaCustom } from 'components';
import { FindLoad, useModal } from 'utils';
import { formActions } from 'store';

export const EditForm = ({ info }) => {
    const ACTION_TYPE = 'EDIT_FORM';
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const { close } = useModal();
    const { handleSubmit, watch, control, setError, clearErrors, reset } = useForm();

    useEffect(() => {
        if (info?.id) {
            reset(info);
        }
    }, [info]);

    const handleCreate = (date) => {
        dispatch(formActions.editForm(info?.id, date));
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">Edit Template</p>
            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <Input
                        name="title"
                        label="Heading*"
                        variant="outlined"
                        control={control}
                        maxLength={60}
                        rules={{
                            maxLength: {
                                value: 60,
                                message: 'Max length is 100 digits.',
                            },
                            required: 'Heading is required.',
                        }}
                    />
                    <TextareaCustom
                        control={control}
                        name="description"
                        label="Description*"
                        variant={'outlined'}
                        allowCharacter={true}
                        rules={{
                            required: 'Description is required.',
                        }}
                    />
                </div>
                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={info?.id ? 'Save' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                />
            </form>
        </div>
    );
};
